import React from "react";
import dayjs from "dayjs";

import { useCalendar } from "../../pages/Calendar/state/CalendarContext";

export default function DayDetails({ date }) {
    const { state } = useCalendar();
    const iso = dayjs(date).format("YYYY-MM-DD");

    const {
        tasks,
        reminders,
        events,
        trackers,
    } = state;

    const birthdays = events.filter(
        (e) => e.isBirthday && e.date === iso
    );

    const normalEvents = events.filter(
        (e) => !e.isBirthday && e.date === iso
    );

    const dailyTasks = tasks.filter(
        (t) => t.dueDate === iso
    );

    const dayReminders = reminders.filter(
        (r) => r.date === iso
    );

    const dayTrackers = trackers.filter((tracker) =>
        tracker.history?.some(
            (h) => dayjs(h.date).format("YYYY-MM-DD") === iso
        )
    );

    const noItems =
        birthdays.length === 0 &&
        normalEvents.length === 0 &&
        dailyTasks.length === 0 &&
        dayReminders.length === 0 &&
        dayTrackers.length === 0;

    return (
        <div style={{ padding: "1rem" }}>
            <h3 style={{ marginTop: 0 }}>
                {dayjs(iso).format("dddd, MMMM D, YYYY")}
            </h3>

            {birthdays.length > 0 && (
                <>
                    <h4>🎉 Birthdays</h4>
                    <ul>
                        {birthdays.map((b) => (
                            <li key={b.id}>{b.title}</li>
                        ))}
                    </ul>
                </>
            )}

            {normalEvents.length > 0 && (
                <>
                    <h4>📅 Events</h4>
                    <ul>
                        {normalEvents.map((e) => (
                            <li key={e.id}>{e.title}</li>
                        ))}
                    </ul>
                </>
            )}

            {dailyTasks.length > 0 && (
                <>
                    <h4>✅ Tasks</h4>
                    <ul>
                        {dailyTasks.map((t) => (
                            <li key={t.id}>{t.text}</li>
                        ))}
                    </ul>
                </>
            )}

            {dayReminders.length > 0 && (
                <>
                    <h4>🔔 Reminders</h4>
                    <ul>
                        {dayReminders.map((r) => (
                            <li key={r.id}>
                                {r.title}
                                {r.time &&
                                    (dayjs(r.time, "HH:mm", true).isValid()
                                        ? ` at ${dayjs(r.time, "HH:mm").format("h:mm A")}`
                                        : ` at ${r.time}`)}
                            </li>
                        ))}
                    </ul>
                </>
            )}

            {dayTrackers.length > 0 && (
                <>
                    <h4>📈 Trackers</h4>
                    <ul>
                        {dayTrackers.map((t) => (
                            <li key={t.id}>{t.title}</li>
                        ))}
                    </ul>
                </>
            )}

            {noItems && (
                <p style={{ fontStyle: "italic", marginTop: "1rem" }}>
                    No items for this date.
                </p>
            )}
        </div>
    );
}
